// colors will be an object who's keys are the formatted string values of the group/category/state names as they appear in the interface.

import theme from 'common/theme';

const intensifierColors = {
  'int1': '#009EB3',
  'int2': '#750985',
  'int3': '#0E00B3',
  'int4': '#C83D95'
}

export const colors: Record<string, string> = {
  ...intensifierColors,
  'intensifier 1': intensifierColors['int1'],
  'intensifier 2': intensifierColors['int2'],
  'intensifier 3': intensifierColors['int3'],
  'intensifier 4': intensifierColors['int4'],
  'int1_stroke_rate_per_minute': intensifierColors['int1'],
  'int2_stroke_rate_per_minute': intensifierColors['int2'],
  'int3_stroke_rate_per_minute': intensifierColors['int3'],
  'int4_stroke_rate_per_minute': intensifierColors['int4'],
  'no product': theme.colors.warning,
  offline: theme.colors.offline,
  'not running': theme.colors.notRunning,
  running: theme.colors.running,
  portions: theme.colors.jbtBlue,
  nuggets: theme.colors.orange1,
  filet: 'pink',
  'cut weight scan': theme.colors.Telemetry1800,
  'cut_weight_scan': theme.colors.Telemetry1800,
  weight: theme.colors.orange1,
  count: theme.colors.jbtBlue,
  percent: theme.colors.Telemetry500,
  speed: theme.colors.Telemetry1200,
  length: theme.colors.running,
  'product output': theme.colors.jbtBlue,
  'product_output': theme.colors.jbtBlue,
  maintenance: 'green',
  Maint: 'green',
  cleaning: 'pink',
  idle: 'gray',
  sterilization: 'purple',
  'wait time': 'yellow',
  'online': theme.colors.running,
  'disconnected': theme.colors.error,
  'unknown': theme.colors.Telemetry1700,
  'load efficiency': theme.colors.Telemetry500,
  'belt efficiency': theme.colors.Telemetry1200,
  'yield': theme.colors.Telemetry1200,
  'output piece': theme.colors.Telemetry500,
  'output weight': theme.colors.Telemetry1800,
  'loading gap': theme.colors.Telemetry1200,
  'overall efficiency': theme.colors.Telemetry1800,
  'processed product percentage': theme.colors.Telemetry1900,
  'infeed piece size': theme.colors.Telemetry2000,
  'throughput piece count': theme.colors.Telemetry2100,
  'belt speed': theme.colors.Telemetry2200,
  'gross yield': theme.colors.Telemetry2300,
  'throughput rate': theme.colors.Telemetry1700,
  'product yield': theme.colors.Telemetry1600,
  'conversion portion rate': theme.colors.Telemetry1500,
  'transition': theme.colors.Telemetry400,
  'production': theme.colors.green,
  'passive cooling': theme.colors.Telemetry1600,
  'forced cooling': theme.colors.Telemetry900,
  'em-stop': theme.colors.darkRed,
  'powering up': theme.colors.orange1,
  'restore': theme.colors.fushia,
  'standby': theme.colors.gray,
  // weight distribution color mapping
  '0-100': theme.colors.Telemetry500,
  '100-200': theme.colors.Telemetry400,
  '200-300': theme.colors.Telemetry600,
  '300-400': theme.colors.Telemetry700,
  '400-500': theme.colors.Telemetry800,
  '500-600': theme.colors.Telemetry900,
  '600-700': theme.colors.Telemetry1000,
  '700-800': theme.colors.Telemetry1100,
  '800-900': theme.colors.Telemetry1200,
  '900-1000': theme.colors.Telemetry1300,
  '1000+': theme.colors.Telemetry1400
};


